import __request__ from "routing/request";
export function createNewKinesisStream(JSONbody) {
  return __request__("POST", "/aws/kinesis/auto_setup/create_stream", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function createSubscription(JSONbody) {
  return __request__("POST", "/aws/kinesis/auto_setup/create_subscription", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function autoKinesisPermissions(JSONbody) {
  return __request__("POST", "/aws/kinesis/auto_setup/create_subscription_policy", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
